import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import assets from "../assets/imgs";
import mainMenus from "../config/menuConfig";
import useIsMobile from "../hooks/useIsMobile";
import config from "../config/config";
import DisabledFeatureModal from "./DisabledFeatureModal";
const API_URL = config.API_URL;

function Sidebar() {
  const isMobile = useIsMobile();
  const location = useLocation();
  const navigate = useNavigate();
  const [showDisabledModal, setShowDisabledModal] = useState(false);

  const handleLogout = async () => {
    try {
      const response = await fetch(`${API_URL}/api/auth/logout`, {
        method: "GET",
        credentials: "include", // 쿠키 포함
      });
  
      if (response.ok) {        
        const data = await response.json();
        console.log(data.message);
        localStorage.removeItem("isLoggedIn");
        window.location.reload();
      } else {
        console.error("Error logout:", response.statusText);
        return false;
      }
    } catch (error) {
      console.error("Error logout:", error);
      return false;
    }
    // navigate("/login");
  };

  // const isActive = (path) => location.pathname === path;
  const isActive = (path) => location.pathname.startsWith(path);

  const handleMenuClick = (e, menu) => {
    if (menu.disabled) {
      e.preventDefault();
      setShowDisabledModal(true);
    }
  };

  if(isMobile){
    return (
      <aside style={mobileStyles.sidebar}>
        <img src={assets.images.img_title} alt="타이틀" style={mobileStyles.sideHead} onClick={() => {
            navigate('/my_page');
          }}/>
        <ul style={mobileStyles.bottomList}>
          <li style={commonMenuLine} onClick={handleLogout}>
            <img src ={assets.icons.logout} style={mobileStyles.menuIcon} alt="로그아웃"/>
            로그아웃
          </li>
        </ul>
      </aside>
    );
  }

  return (
    <aside style={styles.sidebar}>
      <img src={assets.images.img_title} alt="타이틀" style={styles.sideHead} onClick={() => {
          navigate('/my_page');
        }}/>
      <div style={{height: "44px"}}/>
      <nav>
        <ul style={styles.navList}>
          {mainMenus.map((menu) =>(
            <li key={menu.path}>
             <Link
               to={menu.path}
               style={{
                 ...(isActive(menu.path) ? styles.menuLineAct : styles.menuLineDeact),
                 ...(menu.disabled ? styles.disabledMenu : {})
               }}
               onClick={(e) => handleMenuClick(e, menu)}
             >
               <img
                 src={isActive(menu.path) ? assets.icons[menu.iconAct] : assets.icons[menu.iconDeact]}
                 alt={menu.label}
                 style={styles.menuIcon}
               />
               {menu.label}
               {/* isActive(path) 가 true 일 때만 렌더링*/}
               {isActive(menu.path) && !menu.disabled && (
                <>
                  <div style={styles.activeIndicator1} />
                  <ActiveIndicatorTop style={styles.activeIndicatorTop} />
                  <ActiveIndicatorDown style={styles.activeIndicatorDown} />
                </>
                )}
             </Link>
           </li>
          ))}
        </ul>
      </nav>
      <div className="expanded" />
      <ul style={styles.bottomList}>
        <li style={commonMenuLine} onClick={handleLogout}>
          <img src ={assets.icons.logout} style={styles.menuIcon} alt="로그아웃"/>
          로그아웃
        </li>
      </ul>
      {showDisabledModal && (
        <DisabledFeatureModal onClose={() => setShowDisabledModal(false)} />
      )}
    </aside>
  );
}

const ActiveIndicatorTop = ({style}) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="88" height="25" viewBox="0 0 88 25" fill="none" style={style}>
    <path d="M65.509 23.1389C78.0324 22.7832 88 12.5284 88 0V25H0L65.509 23.1389Z" fill="white" />
  </svg>
);
const ActiveIndicatorDown = ({style}) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="88" height="25" viewBox="0 0 88 25" fill="none" style={style}>
    <path d="M65.509 1.86105C78.0324 2.21683 88 12.4716 88 25V0H0L65.509 1.86105Z" fill="white"/>
  </svg>
);


const commonMenuLine = {
  display: "flex", alignItems:"center", fontSize: "14px", fontWeight: "500", 
  padding: "12px", position: "relative", cursor: "pointer"
};
const commonActiveIndicator ={
  backgroundColor: "var(--primary-crimson_60)",
  position: "absolute",
}
const styles = {
  sidebar: {
    display: "flex",
    flexDirection: "column",
    width: "200px",
    // height: "100vh",
    backgroundColor: "var(--primary-crimson_60)",
    color: "white",
    padding: "44px 24px",
    borderTopRightRadius: "32px"
  },
  sideHead: {
    width: "191px",
    cursor: "pointer",
  },
  navList: {
    listStyle: "none",
    gap: "12px",
    padding: 0,
    margin: 0,
  },
  navItem: {
    marginBottom: "1rem",
  },
  logout: {
    color: "white",
  },
  menuLineAct: {
    ...commonMenuLine,
    backgroundColor: "white",
    color: "var(--primary-crimson_60)",
    borderRadius :"12px 0px 0px 12px",
  },
  menuLineDeact: {
    ...commonMenuLine,
  },
  activeIndicator1: {
    backgroundColor: "white",
    height: "100%", width: "24px",
    position: "absolute", right: "-24px",
  },
  activeIndicatorTop: {
    ...commonActiveIndicator,
    right: "-24px", top: "-25px"
  },
  activeIndicatorDown: {
    ...commonActiveIndicator,
    right: "-24px", bottom: "-25px"
  },
  menuIcon:{
    width: "24px", marginRight: "20px",
  },
  disabledMenu: {
    opacity: 0.5,
    cursor: "not-allowed",
  },
};

const mobileStyles = {
  sidebar: {
    display: "flex",
    backgroundColor: "var(--primary-crimson_60)",
    color: "white",
    padding: "20px",
    justifyContent: "space-between",
    alignItems: "center",
    borderRadius: "0px 0px 15px 15px",
  },
  sideHead: {
    width: "191px",
    cursor: "pointer",
    borderRadius: "8px"
  },
  menuIcon:{
    width: "24px", marginRight: "20px",
  },
};

export default Sidebar;